import { ColumnOptions, Item } from '@/types/ColumnOptions'
import { ColumnFilterConfiguration } from '@/types/CustomDataTable'
import { AdditionalInformation, Fraction } from '@/types/DestinationCatalog'

export enum DestinationCatalogFields {
  None = 0,
  CatalogName = 1,
  Status = 2,
  Channels = 3,
  AppliedCreativeAutomation = 4,
  OptimizedProducts = 5,
  LastSynced = 6,
  Action = 7
}

export const ATTRIBUTES: Item[] = [
  {
    title: 'Catalog Name',
    key: 'name',
    sortable: true,
    maxWidth: '110px',
    id: DestinationCatalogFields.CatalogName
  },
  {
    title: 'Status',
    key: 'status',
    sortable: true,
    maxWidth: '70px',
    id: DestinationCatalogFields.Status
  },
  {
    title: 'Applied Creative Automation',
    key: 'appliedCreativeAutomation',
    sortable: false,
    maxWidth: '130px',
    id: DestinationCatalogFields.AppliedCreativeAutomation
  },
  {
    title: 'Channels',
    key: 'channels',
    sortable: false,
    maxWidth: '50px',
    id: DestinationCatalogFields.Channels
  },
  {
    title: 'Optimized Products',
    key: 'insightsData',
    sortable: false,
    maxWidth: '130px',
    id: DestinationCatalogFields.OptimizedProducts
  },
  {
    title: 'Last Synced',
    key: 'lastSynced',
    sortable: true,
    maxWidth: '90px',
    id: DestinationCatalogFields.LastSynced
  },
  {
    title: 'Action',
    key: 'action',
    sortable: false,
    maxWidth: '50px',
    id: DestinationCatalogFields.Action
  }
]

export const SELECTION_OPTIONS: string[] = ['Attributes']

export const ATTRIBUTE_OPTIONS: ColumnOptions[] = [
  {
    id: 1,
    title: 'Attributes',
    items: ATTRIBUTES
  }
]

export const COLUMN_FILTER_CONFIGURATION: ColumnFilterConfiguration = {
  selectionOptions: SELECTION_OPTIONS,
  attributeOptions: ATTRIBUTE_OPTIONS,
  metricOptions: []
}

export const sampleFractions: Fraction[] = [
  {
    name: 'Fallback',
    enrichmentConfig: {
      title: {
        templateId: null,
        format: '',
        selectedKeyword: null,
        selectedTag: null
      },
      description: {
        contentLength: 1,
        enrichmentTone: {
          tone: null,
          season: null,
          festival: null
        },
        prompt: null
      }
    },
    ruleJson: null,
    priority: 0,
    isExpansionPanelOpen: true
  }
]

export const sampleConfigJson: AdditionalInformation = Object.freeze({
  isAutoAuditSync: true,
  applyBgRemoval: false,
  fractions: null,
  feedExportConfig: null
})

export const normalizeFraction = (fraction: Fraction): Fraction => {
  if (!fraction.enrichmentConfig) {
    fraction.enrichmentConfig = JSON.parse(
      JSON.stringify(sampleFractions[0].enrichmentConfig)
    )
  } else {
    if (!fraction.enrichmentConfig.title) {
      fraction.enrichmentConfig.title = JSON.parse(
        JSON.stringify(sampleFractions[0].enrichmentConfig.title)
      )
    }
    if (!fraction.enrichmentConfig.description) {
      fraction.enrichmentConfig.description = JSON.parse(
        JSON.stringify(sampleFractions[0].enrichmentConfig.description)
      )
    }
  }
  return fraction
}
